import { useCallback, useEffect } from 'react';

import fetchHeroPlannerBrands from '~/actions/customerCommunication/fetchHeroPlannerBrands';

import { useAppDispatch, useAppSelector } from '../store';

function useHeroPlannerBrands() {
  const brandsReq = useAppSelector((state) => state.customerCommunication.brands);
  const appDispatch = useAppDispatch();
  const fetchBrands = useCallback(() => {
    appDispatch(fetchHeroPlannerBrands());
  }, [appDispatch]);
  useEffect(() => {
    fetchBrands();
  }, [fetchBrands]);

  return { brandsReq, fetchBrands };
}

export default useHeroPlannerBrands;
